// Informational notice only: shown until the visitor clicks OK, remembered for 12 months.
const NOTICE_COOKIE = 'pbt_cookie_notice'
const MAX_AGE = 60 * 60 * 24 * 365

export const initCookieBar = () => {
  const bar = document.querySelector('.js-cookie-bar')
  if (!bar) return

  if (document.cookie.match(new RegExp(`(?:^|; )${NOTICE_COOKIE}=`))) return

  bar.hidden = false
  document.body.classList.add('cookie-bar-open')

  bar.querySelector('.js-cookie-ok').addEventListener('click', () => {
    document.cookie = `${NOTICE_COOKIE}=ok; max-age=${MAX_AGE}; path=/; SameSite=Lax`
    bar.hidden = true
    document.body.classList.remove('cookie-bar-open')
  })
}
